import type { CSSProperties } from 'react'
import type { DashboardCard } from '../api/dashboard'
import { placeLinks } from './cardLinks'

/**
 * Locul unui card: markupul din index.php in jur, HTML-ul cardului din API
 * (CardMarkup, acelasi ca card.php).
 *
 * `.odb-card` E COPILUL DIRECT AL LOCULUI, FARA NICIUN INVELIS.
 * -----------------------------------------------------------------------------
 * `dangerouslySetInnerHTML` cere un element al lui, si el statea pe un `<div>`
 * pus in plus intre `.odb-slot` si card. Nimic nu se vedea din asta cat timp
 * grila crestea singura - dar grila NU creste: `.odb` are randuri de inaltime
 * fixa (`grid-auto-rows: var(--odb-cell)`), si tot ce tine cardul in celula se
 * scrie in `od_dashboard.css` pe COPILUL DIRECT:
 *
 *     .odb-slot > .odb-card { min-height: 0; overflow: hidden; flex: 1 1 auto; }
 *
 * Cu invelisul la mijloc, selectorul nu se potriveste: cardul nu se mai taie la
 * marginea celulei si nu se mai intinde pe toata ea. Un card cu o lista de sase
 * randuri crestea la 357px intr-o celula de 241 si se aseza PESTE cardul de sub
 * el - masurat in Chromium la 1600 si la 1280: sase suprapuneri, cea mai mare
 * de 389x98px. Un card cu o singura cifra ramanea de 96px intr-o celula de 241,
 * adica scund si desprins de vecini.
 *
 * De-aia HTML-ul se pune DIRECT pe `.odb-slot`, exact ca in `index.php`, unde
 * `load->view('dashboard/card')` scrie cardul acolo fara nimic in jur.
 *
 * CONSTRUCTORUL NU E AICI: locul care se muta si se schimba de marime, cu
 * uneltele lui, e in `BoardBuilder` - acolo cardul poarta un invelis, stiut,
 * fiindca uneltele sunt frati scrisi in JSX.
 */
export function DashboardCardSlot({ card }: { card: DashboardCard; edit?: boolean; sizes?: unknown }) {
  const placed = card.x != null && card.y != null
  const place = placed
    ? ({
        '--gx': (card.x as number) + 1,
        '--gy': (card.y as number) + 1,
        '--gw': card.w,
        '--gh': card.h,
      } as CSSProperties)
    : undefined

  return (
    <div
      className={`odb-slot odb-x${card.w} odb-y${card.h}${placed ? ' odb-placed' : ''}`}
      data-card={card.id}
      data-size={card.size}
      style={place}
      dangerouslySetInnerHTML={{ __html: placeLinks(card.html) }}
    />
  )
}
